import { FC } from 'react'
import { MenuItem } from '@getgo/chameleon-web-react-wrapper'

interface MainMenuItemProps {
  name: string
  count: number
  onClick: () => void
}

const MainMenuItem: FC<MainMenuItemProps> = ({ name, count, onClick, ...props }) => (
  <MenuItem
    title={`${name} (${count})`}
    onClick={(event) => {
      event.preventDefault()
      onClick()
    }}
    {...props}
  >
    {name} ({count})
  </MenuItem>
)

export default MainMenuItem
